// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer à la main.
// Régénérer : node scripts/gen-nb-cp.mjs
// Vérifier  : node scripts/gen-nb-cp.mjs --verifier
//
// Le pourquoi complet est en tête de scripts/gen-nb-cp.mjs : ces deux nombres
// sont DÉRIVÉS de app/lib/baremes-cp-grid.js, mais au build. Les dériver à
// l'exécution embarquait 1 223 Ko de barèmes dans le navigateur sur /vitrine
// et /pricing, deux pages 'use client', pour afficher un entier.
//
// Le verrou __tests__/nb-cp-genere.test.js recalcule depuis la grille et
// échoue si ce fichier a dérivé : la valeur ne peut donc ni périmer ni être
// inventée — c'est la propriété que nb-cp.js protégeait, et elle est gardée.

/** Commissions paritaires dont le barème est connu et vérifié. */
export const NB_CP = 128;

/** Le total du registre, entrées documentaires comprises. */
export const NB_CP_REGISTRE = 203;
